// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateNextLocation = data => ({
    data,
    type: actions.UPDATE_USER_PREFERENCES_NEXT_LOCATION
});



// WEBPACK FOOTER //
// ./src/user/shared/action-creators/update-next-location.js